import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, InputNumber, Segmented, message } from 'antd';
import axios from 'axios';

const quantityTypeOptions = [
  { label: 'Kilograms', value: 'metric' },
  { label: 'Pounds', value: 'imperial' },
];

const TrackWeightModal = ({ preferredQuantityType = 'metric', onSaved }) => {
  const [visible, setVisible] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  // Set initial form values when modal opens or preferredQuantityType changes
  useEffect(() => {
    if (visible) {
      form.setFieldsValue({ quantityType: preferredQuantityType, quantity: undefined });
    }
  }, [visible, preferredQuantityType, form]);

  const openModal = () => {
    setVisible(true);
    // form.resetFields(); // optional reset handled by useEffect
  };

  const closeModal = () => {
    setVisible(false);
  };

  const onSave = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        quantity: values.quantity,
        quantityType: values.quantityType,
      };
      setSaving(true);
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/track-weights`,
        payload,
        { withCredentials: true }
      );
      messageApi.success('Weight update saved.');
      setVisible(false);
       onSaved();
    } catch (error) {
      messageApi.error('Failed to save weight');
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      {contextHolder}
      <Button type="primary" onClick={openModal}>
        Track Weight
      </Button>
      <Modal
        title="Track Weight"
        open={visible}
        onCancel={closeModal}
        onOk={onSave}
        okText="Save"
        cancelText="Cancel"
        confirmLoading={saving}
      >
        <Form
          form={form}
          layout="vertical"
          name="trackWeightForm"
          initialValues={{ quantityType: preferredQuantityType }}
        >
          <Form.Item
            name="quantity"
            label="Quantity"
            rules={[{ required: true, message: 'Please enter the weight quantity' }]}
          >
            <InputNumber min={0} style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            name="quantityType"
            label="Quantity Type"
            rules={[{ required: true, message: 'Please select quantity type' }]}
          >
            <Segmented options={quantityTypeOptions} block onChange={val => form.setFieldsValue({ quantityType: val })} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default TrackWeightModal;
